import React from 'react';

export interface LinkArrowProps {
  className?: string;
}

const LinkArrow: React.FC<LinkArrowProps> = ({ className }) => {
  return (
    <svg
      viewBox="0 0 5 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.29293 1H0.500038V0H5.00004V4.5H4.00004V1.70711L0.853591 4.85355L0.146484 4.14645L3.29293 1Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default LinkArrow;
